<template>
    <span v-if="compareId !== patientId">
        <i class="fa fa-star appointment-priority cursor-pointer w3-large"
        v-bind:class="appointmentHasPriorityProp ? 'active' : 'inactive'"
        @click="changePriority"
        :title="appointmentHasPriorityProp ? $t('removePriority') : $t('givePriority') ">
        </i>
    </span>
    <span v-else>
        <i class="fa fa-spinner w3-spin w3-large w3-opacity w3-disabled transform-animation">
        </i>
    </span>
</template>

<script>
    import Vue from 'vue';
    import { EventBus } from "../../main";

    let frc = Vue.prototype.$frc;

    export default {
        name: "AppointmentPriority",
        components: {},
        props: ['appointmentId', 'patientId' , 'appointmentHasPriority'],
        data: function() {
            return {
                compareId: undefined
            }
        },
        computed: {
            appointmentHasPriorityProp: {
                get() { return this.appointmentHasPriority},
                set(val) { this.$emit('update:appointmentHasPriority', val)}
            }
        },
        watch: {
            appointmentHasPriority: function(newVal, oldVal) {
                this.appointmentHasPriorityProp = newVal;
            }
        },
        methods: {
            changePriority: function () {
                var app = this;
                app.compareId = app.patientId;
                var newPr = !this.appointmentHasPriorityProp;
                frc.setPriority(app.patientId, app.appointmentId, newPr).then( function (res) {
                    app.appointmentHasPriorityProp = newPr;
                    app.compareId = undefined;
                    EventBus.$emit("priorityUpdated", app.patientId);
                }).catch(function(e) {
                    console.log(e);
                    app.compareId = undefined;
                });
            }
        }
    }
</script>